import { Controller } from '@hotwired/stimulus'
import { MaskInput } from 'maska'

export default class extends Controller {
  static values = { type: String }

  static MASK_OPTIONS = {
    money: { number: { locale: 'en', fraction: 2, unsigned: true } },
    phone: { mask: '+1 (###) ###-####', eager: true }
  }

  connect () {
    this.maskInput = new MaskInput(this.element, this._getMaskOptions())

    switch (this.typeValue) {
      case 'money':
        this.formatMoneyHandler = this._formatMoney.bind(this)
        this.element.addEventListener('blur-sm', this.formatMoneyHandler)
        break
    }
  }

  _getMaskOptions () {
    return this.constructor.MASK_OPTIONS[this.typeValue] || {}
  }

  _formatMoney () {
    const value = this.element.value.replace(/,/g, '')
    if (value === '') return

    this.element.value = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(parseFloat(value))
  }

  disconnect () {
    if (this.formatMoneyHandler) {
      this.element.removeEventListener('blur-sm', this.formatMoneyHandler)
      this.formatMoneyHandler = null
    }

    if (this.maskInput) {
      this.maskInput.destroy()
      this.maskInput = null
    }
  }
}
